import F1Picture from './F1Picture'

// Hero (Figma 5404:6325 / 5413:7898 / 5417:12906): every breakpoint export
// bakes in the headline, the F1 | Heineken 0.0 lockup, the e-bug and the
// legal line, so the DOM only renders the image (no duplicated copy).
const Hero = () => {
  return (
    <section className="pitstops__hero">
      <F1Picture name="hero" className="pitstops__hero-media" alt="Los fans tienen más amigos." />
    </section>
  )
}

export default Hero
